module.exports = __webpack_public_path__ + "e5d0f82d5e5732570382fd9b326a7243.svg";